import React, { FC, useState } from "react";
import "./index.scss";
import { getHexColor } from "../../helpers";

interface Props {
  title: string;
  mobileTitle: string;
  visible: boolean;
  details: string;
  backgroundColor?: string;
  textColor?: string;
}

const InfoPane: FC<Props> = ({
  visible,
  title,
  mobileTitle,
  details,
  backgroundColor,
  textColor
}) => {
  if (!visible) return null;
  const [isExpanded, setIsExpanded] = useState(false);
  const schemaColors: Record<string, string> = {
    "--info-bg-color": backgroundColor
      ? getHexColor(backgroundColor)
      : "var(--color-green)",
    "--info-text-color": textColor
      ? getHexColor(textColor)
      : "var(--color-white)"
  };
  return (
    <div
      className={`info-pane ${isExpanded ? "expanded" : ""}`}
      style={schemaColors}
    >
      <button
        className="info-pane__toggle"
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
      ></button>
      <div className="info-pane__title">{title}</div>
      <div className="info-pane__title--mobile">{mobileTitle}</div>
      <div
        className="info-pane__details"
        dangerouslySetInnerHTML={{
          __html: details
        }}
      ></div>
    </div>
  );
};

export default InfoPane;
